/* eslint-disable import/prefer-default-export */
import FolderSearchIcon from "../../assets/logos/FolderSearchIcon.svg";
import Applications from "../../assets/logos/Applications.svg";
import RevenueLoss from "../../assets/logos/RevenueLoss.svg";
import Trendup from "../../assets/logos/Trendup.svg";
import ClockIcon from "../../assets/logos/Risk.svg";
import DocumentsIcon from "../../assets/logos/Document.svg";
import WarningIcon from "../../assets/logos/WarningIcon.svg";
import SuccessIcon from "../../assets/logos/Risk.svg";

export const KEY_INSIGHTS_CONFIG = {
  potentialDuplicatesToday: {
    title: "Potential Duplicates as of Today",
    icon: FolderSearchIcon,
    labelIcon: Trendup,
    hintSuffix: "match",
  },
  applicationsReviewedToday: {
    title: "Applications Reviewed as of Today",
    icon: Applications,
    labelIcon: Trendup,
    hintSuffix: "/day",
  },

  // Document Agent metrics
  warning: {
    title: "Error Rate",
    icon: WarningIcon,
    labelIcon: Trendup,
  },
  clock: {
    title: "Application Processing Time",
    icon: ClockIcon,
    labelIcon: Trendup,
  },
  documents: {
    title: "Application Document Quality",
    icon: DocumentsIcon,
    labelIcon: Trendup,
  },
  success: {
    title: "Success Rate",
    icon: SuccessIcon,
    labelIcon: Trendup,
  },
};
